export default __webpack_public_path__ + "static/NAACP_EmpowermentPrograms-Blue-CMYK-01-26d11de44fd5b6517d17b562cd5eb369.png";